import { render, staticRenderFns } from "./DrDashboard.vue?vue&type=template&id=65a500bf&"
import script from "./DrDashboard.vue?vue&type=script&lang=js&"
export * from "./DrDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports